import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/gerb.png'
import _imports_1 from '@/assets/img/svg/personMob.svg'
import _imports_2 from '@/assets/img/svg/personAuth.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header_row" }
const _hoisted_4 = { class: "header_auth-container" }
const _hoisted_5 = {
  key: 0,
  class: "header_auth-login"
}
const _hoisted_6 = {
  key: 1,
  class: "header_auth-login"
}
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "header_auth-container" }
const _hoisted_9 = {
  key: 0,
  class: "header_auth-login"
}
const _hoisted_10 = {
  key: 1,
  class: "header_auth-login"
}
const _hoisted_11 = { class: "header_menu-main-container" }
const _hoisted_12 = { class: "header_menu-main" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "header_menu-sub"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VisuallyImpaired = _resolveComponent("VisuallyImpaired")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_SwitchComponentHeader = _resolveComponent("SwitchComponentHeader")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["burger", { open: _ctx.burgerOpen }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.burgerOpen = !_ctx.burgerOpen))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "top" }, null, -1),
          _createElementVNode("span", { class: "mid" }, null, -1),
          _createElementVNode("span", { class: "bot" }, null, -1)
        ]))], 2),
        _createVNode(_component_router_link, {
          class: "header_logo-container",
          to: "/"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("img", {
              class: "header_logo",
              src: _imports_0,
              alt: "Герб РФ"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "header_title",
          to: "/"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createElementVNode("h1", null, "Единый портал внешнеэкономической информации Минэкономразвития России", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_VisuallyImpaired, { class: "ml-2" }),
          (!_ctx.$store.state.auth?.oidc?.isLoggedOn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", {
                  class: "header_auth-link",
                  href: "#",
                  title: "Войти",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_IconComponent, { name: "person" })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/account-settings",
                  title: "Настройки"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconComponent, { name: "personAuth" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/logout" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Выйти ", -1)
                  ]))]),
                  _: 1
                })
              ])),
          _createVNode(_component_SwitchComponentHeader, {
            class: "switcher-container",
            textTrue: "Ru",
            textFalse: "En"
          })
        ])
      ])
    ]),
    _createElementVNode("section", {
      class: _normalizeClass(["header_menu-section", { open: _ctx.burgerOpen }])
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_VisuallyImpaired, { class: "ml-2" }),
          (!_ctx.$store.state.auth?.oidc?.isLoggedOn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("a", {
                  class: "header_auth-link",
                  href: "#",
                  title: "Войти",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("img", { src: _imports_1 }, null, -1)
                ]))])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: "/account-settings",
                  title: "Настройки"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("img", { src: _imports_2 }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/logout" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Выйти ", -1)
                  ]))]),
                  _: 1
                })
              ])),
          _createVNode(_component_SwitchComponentHeader, {
            class: "switcher-container",
            textTrue: "Ru",
            textFalse: "En"
          })
        ]),
        _createElementVNode("nav", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerMenu, (headerItem, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "header_menu-main-item",
                key: index,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.burgerOpen = false))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["header_menu-main-itemContainer", { openMobileMenu: _ctx.openMobilSubMenuIndex == index }])
                }, [
                  (headerItem.id == 23)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: headerItem.link,
                        target: "_blank",
                        class: "header_menu-main-itemLink"
                      }, _toDisplayString(headerItem.name), 9, _hoisted_13))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (headerItem.link.startsWith('http'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: headerItem.link,
                              target: "_blank"
                            }, _toDisplayString(headerItem.name), 9, _hoisted_14))
                          : (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: headerItem.link,
                              class: _normalizeClass(["header_menu-main-itemLink", { 'router-link-active': _ctx.isActiveMenu(headerItem.link) }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(headerItem.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "class"]))
                      ], 64))
                ], 2),
                (headerItem.submenu && headerItem.submenu.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerItem.submenu, (header, submenuIndex) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "header_menu-sub-item",
                          key: submenuIndex
                        }, [
                          _createVNode(_component_router_link, {
                            to: header.link,
                            class: _normalizeClass({ 'router-link-active': _ctx.isActiveMenu(header.link, 'submenu') })
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(header.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ], 2)
  ])), [
    [_directive_click_outside, _ctx.onClickOutside]
  ])
}